import * as React from "react";
import { UitkMenu, UitkMenuTrigger, UitkMenuContainer, PositionType } from "uitk-react-menu";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
import { UitkHeading, UitkText } from "uitk-react-text";
import { useLocalization } from "@shared-ui/localization-context";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkLayoutPosition } from "uitk-react-layout-position";
import { UitkMoreInfoTrigger } from "uitk-react-more-info-trigger";
import { ICarAddressMenu } from "./typings";
import { locKeys } from "./i10n";

export const CarAddressMenu: React.FC<ICarAddressMenu> = ({ locationText, locationAddress, locationDistanceInfo }) => {
  const { formatText } = useLocalization();
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  const onMenuClick = (event: React.MouseEvent) => {
    event.preventDefault();
    setIsMenuOpen((prevState) => !prevState);
  };

  const { distanceAmount, distanceUnit, city } = { ...locationDistanceInfo };
  const showPickupDistance = distanceAmount && distanceUnit && city;

  return (
    <UitkLayoutPosition type="relative" position={{ zindex: "layer2" }}>
      <UitkMenu isOpen={isMenuOpen} onTriggerClick={onMenuClick}>
        <UitkMenuTrigger>
          <div>
            <UitkSpacing padding={{ blockend: "one" }}>
              <UitkMoreInfoTrigger>
                <a href="" role="button">
                  {locationText}
                  <UitkSpacing padding={{ inlinestart: "one" }}>
                    <UitkIcon name="info_outline" size={UitkIconSize.SMALL} />
                  </UitkSpacing>
                </a>
              </UitkMoreInfoTrigger>
            </UitkSpacing>
          </div>
        </UitkMenuTrigger>
        <UitkMenuContainer width={225} position={PositionType.LEFT}>
          <UitkSpacing padding={{ inline: "three" }}>
            <div>
              <UitkHeading size={7} tag="h4">
                {formatText(locKeys.pickUpLocationText)}
              </UitkHeading>
              <UitkText size={200} spacing="two">
                {locationAddress}
              </UitkText>
              {showPickupDistance && (
                <UitkText size={200} spacing="two">
                  {formatText(locKeys.locationDistanceText, distanceAmount, distanceUnit, city)}
                </UitkText>
              )}
            </div>
          </UitkSpacing>
        </UitkMenuContainer>
      </UitkMenu>
    </UitkLayoutPosition>
  );
};
